import { ClipboardList, FileText, Library, type LucideIcon } from "lucide-react";

import { useInspector } from "@/contexts/InspectorContext";

interface TabOption {
  kind: string;
  icon: LucideIcon;
  title: string;
  description: string;
  open: () => void;
}

export function NewTabSelector() {
  const inspector = useInspector();

  const options: TabOption[] = [
    {
      kind: "citations",
      icon: FileText,
      title: "Citations",
      description: "Review citations for the selected answer",
      open: () =>
        inspector.openTab({
          kind: "citations",
          id: "citations",
          title: "Citations",
          payload: { citations: inspector.chatCitations },
        }),
    },
    {
      kind: "worklog",
      icon: ClipboardList,
      title: "Worklog",
      description: "View agent activity across all turns",
      open: () =>
        inspector.openTab({
          kind: "worklog",
          id: "worklog",
          pinned: true,
          title: "Worklog",
          payload: {},
        }),
    },
    {
      kind: "sources",
      icon: Library,
      title: "Documents",
      description: "View all source documents used in this chat",
      open: () =>
        inspector.openTab({
          kind: "sources",
          id: "sources",
          title: "Documents",
          payload: {},
        }),
    },
  ];

  return (
    <div className="flex h-full flex-col p-4">
      <h2 className="mb-4 text-sm font-medium text-muted-foreground">New tab</h2>
      <div className="space-y-1">
        {options.map((option) => (
          <button
            key={option.kind}
            type="button"
            onClick={option.open}
            className="flex w-full items-start gap-3 rounded-md p-3 text-left transition-colors hover:bg-muted"
          >
            <option.icon className="mt-0.5 size-4 shrink-0 text-muted-foreground" />
            <div className="min-w-0">
              <div className="text-sm font-medium">{option.title}</div>
              <div className="text-xs text-muted-foreground">{option.description}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
